/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { toAbsoluteUrl, KTSVG } from '../../../../../../../../_metronic/helpers'
import { SearchInput } from '../../../../../../components/SearchInput'
import { getPlantsAllSimple } from '../../../../../../../services/plantsService'
import { useToast } from '../../../../../../components/Toats'
import { Loading } from '../../../../../../components/Loadings/loading'
import useSize from '../../../../../../../hooks/useSize'
import { useQuery } from 'react-query'
import { useAuth } from '../../../../../../../modules/auth'

type Props = {
  className: string;
  formik: any;
  hasError?: any;
  idUnitBranch?: string | null;
  show?: boolean;
  linkedPlantsIds?: string[];
  includeAlreadyLinked?: boolean;
}

const ListPlantsForComposite: React.FC<Props> = ({className, formik, hasError, idUnitBranch, show = false, linkedPlantsIds = [], includeAlreadyLinked = true}) => {

  const [control, setControl] = useState(false);
  const [mySearch, setMySearch] = useState<any[]>([]);
  const { toggleToast } = useToast();
  const {width: largura} = useSize();
  const {currentUser} = useAuth();

  const { data: plants = [], isLoading: loading } = useQuery<any[]>(
    ["getPlantsSimpleForComposite", includeAlreadyLinked, idUnitBranch],
    async () => {
      if(currentUser && currentUser.role && currentUser.role.slug !== "ADMIN"){
        let url = `?type_plant=SIMPLES&activeMark=true`;
        if (includeAlreadyLinked) {
          url += `&isIncludedComposite=true`;
        }
        if (idUnitBranch) {
          url += `&unitBranch=${idUnitBranch}`;
        }
        const myPlants = await getPlantsAllSimple(url);
        return myPlants;
      }else{
        return [];
      }
    },
    {
      enabled: show,
      onError: (error) => {
        console.log(error);
        toggleToast("Erro ao buscar as usinas.", "error");
      },
    }
  );

  // console.log("plants", plants);
  // console.log("idUnitBranch", idUnitBranch);

  // const filteredPlants = idUnitBranch 
  //   ? plants.filter((plant: any) => plant.unitBranch && plant.unitBranch.id === idUnitBranch)
  //   : [];
    

  // const plantsToUse = idUnitBranch ? filteredPlants : plants;

  const plantsToUse = plants;

  const updateData = (value: string, checked: boolean) => {
    const currentIds = formik.values.idsPlants || [];
    
    if (linkedPlantsIds.includes(value)) {
      toggleToast("Esta usina já está vinculada à usina composta.", "warning");
      return;
    }
    
    if(checked === true){
      const plantToAdd = plantsToUse.find((plant: any) => plant.id === value);
      if (plantToAdd && plantToAdd.mark) {
        
        // Verificar se já existe uma usina da mesma marca nas selecionadas
        // const existingPlantWithSameMark = currentIds.find((id: string) => {
        //   const existingPlant = plantsToUse.find((p: any) => p.id === id);
        //   return existingPlant && existingPlant.mark && existingPlant.mark.id === plantToAdd.mark.id;
        // });
        
        // // Verificar se já existe uma usina da mesma marca nas já vinculadas
        // const linkedPlantWithSameMark = linkedPlantsIds.find((id: string) => {
        //   const linkedPlant = plantsToUse.find((p: any) => p.id === id);
        //   return linkedPlant && linkedPlant.mark && linkedPlant.mark.id === plantToAdd.mark.id;
        // });
        
        // if (existingPlantWithSameMark || linkedPlantWithSameMark) {
        //   toggleToast("Apenas 1 usina por marca (portal) pode ser selecionada.", "warning");
        //   return;
        // }
      }
      
      formik.setFieldValue('idsPlants', [...currentIds, value]);
    } else {
      formik.setFieldValue('idsPlants', currentIds.filter((id: string) => id !== value));
    }
  }

  useEffect(() => {
    if (idUnitBranch) {
      formik.setFieldValue('idsPlants', []);
    } else {
      formik.setFieldValue('idsPlants', []);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idUnitBranch]);

  const plantsToDisplay = control ? mySearch : plantsToUse;
  const currentIds = formik.values.idsPlants || [];
  
  return (
    <div className={`card ${className}`} style={{paddingBottom: '2rem', flex: '1'}}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5' style={{alignItems: 'center'}}>
        <div>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold text-dark'>Lista de usinas SIMPLES</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>Selecione as usinas para vincular à usina COMPOSTAA</span>
          </h3>
        </div>

        <div className='d-flex gap-2 align-items-center'>
          <SearchInput 
            className={`form-control form-control-solid bg-body ps-14 ${largura < 1200 ? "fs-7" : ""}`}
            placeholder='Buscar pelo nome'
            myDate={plantsToUse}
            setMySearch={setMySearch}
            control={control}
            style={{width: largura < 1200 ? "100%" : "300px", flex: '1'}}
            setControl={setControl}
            searchParameter="name"
            disabled={loading}
          />
          <button
            type='button'
            className='btn btn-sm btn-light btn-active-primary'
            onClick={() => {
              formik.setFieldValue('idsPlants', []);
              toggleToast("Seleções limpas.", "info");
            }}
            disabled={loading || !formik.values.idsPlants || formik.values.idsPlants.length === 0}
            title={`Limpar seleções: ${formik.values.idsPlants.length} usinas selecionadas`}
            style={{cursor: 'pointer', padding: '0.5rem'}}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr097.svg' className='svg-icon-1' />
          </button>
        </div>
      </div>

      <div className='card-body pt-5' style={{height: '20rem', overflowY: "auto"}}>
        {loading ? (
          <div className='d-flex align-items-center justify-content-center' style={{height: '100%'}}>
            <Loading myClass='spinner-border' />
          </div>
        ) : (
          <>
            {plantsToDisplay && plantsToDisplay.length > 0 ? (
              plantsToDisplay.map((plant: any) => {
                const isChecked = currentIds.includes(plant.id);
                const isLinked = linkedPlantsIds.includes(plant.id);
                //const isLinked = false;
                //const plantMarkId = plant.mark?.id;
                
                // // Verificar se há outra usina da mesma marca selecionada
                // const hasOtherPlantWithSameMarkSelected = currentIds.some((id: string) => {
                //   if (id === plant.id) return false;
                //   const otherPlant = plantsToUse.find((p: any) => p.id === id);
                //   return otherPlant && otherPlant.mark?.id === plantMarkId;
                // });
                
                // // Verificar se há outra usina da mesma marca já vinculada
                // const hasOtherPlantWithSameMarkLinked = linkedPlantsIds.some((id: string) => {
                //   if (id === plant.id) return false;
                //   const linkedPlant = plantsToUse.find((p: any) => p.id === id);
                //   return linkedPlant && linkedPlant.mark?.id === plantMarkId;
                // });
                
                //const hasOtherPlantWithSameMark = hasOtherPlantWithSameMarkSelected || hasOtherPlantWithSameMarkLinked;
                const hasOtherPlantWithSameMark = false;
                return (
                  <div key={plant.id} className='d-flex align-items-center mb-7' style={{justifyContent: 'space-between'}}>
                    {/* begin::Symbol */}
                    <div className='d-flex align-items-center' style={{flex: '4'}}>
                      <div className={`symbol symbol-${largura < 1200 ? '40px' : '50px'} me-5`}>
                        <span className='symbol-label' style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                          <div className={`symbol symbol-${largura < 1200 ? '40px' : '50px'}`} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <img src={toAbsoluteUrl('/media/imgs/plant2.png')} className='' alt='' />
                          </div>
                        </span>
                      </div>
                      <div className='d-flex flex-column'>
                        <a href='#' className={`text-dark text-hover-primary fs-${largura < 1200 ? '7' : '6'} fw-bold`}>
                          {plant.name}
                        </a>
                        <span className={`text-muted fw-semibold fs-${largura < 1200 ? '7' : '6'}`}>
                          {plant.address ? plant.address : "Não localizado."}
                        </span>
                        {plant.mark && (
                          <span className={`text-muted fw-semibold d-flex align-items-center gap-2 fs-${largura < 1200 ? '7' : '6'}`}>
                            <span className='fw-bold text-gray-600'>Marca (PORTAL): </span>
                            <div className={`symbol symbol-30px`} style={{cursor: 'pointer'}} title={plant.mark.name ? plant.mark.name : ""}>
                              <img src={toAbsoluteUrl(plant.mark.link_imagem ? plant.mark.link_imagem : "/media/imgs/plant2.png")} className='' alt='' />
                            </div>
                          </span>
                        )}
                        {isLinked && (
                          <span className='text-success fw-semibold fs-7'>
                            Já vinculada à usina composta
                          </span>
                        )}
                        {hasOtherPlantWithSameMark && !isChecked && !isLinked && (
                          <span className='text-warning fw-semibold fs-7'>
                            Já existe uma usina deste portal selecionada
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='form-check form-check-custom form-check-primary form-check-solid mx-5' style={{flex: '1', display: 'flex', justifyContent: 'end'}}>
                      <input
                        className={`form-check-input ${!isChecked && !isLinked ? 'bg-secondary' : ''}`} 
                        type='checkbox'
                        checked={isChecked || isLinked}
                        value={plant.id}
                        disabled={isLinked || (hasOtherPlantWithSameMark && !isChecked)}
                        onChange={(e) => {
                          updateData(e.target.value, e.target.checked)
                        }}
                      />
                    </div>
                    {/* end::Text */}
                  </div>
                )
              })
            ) : (
              <div className='d-flex align-items-center mb-7' style={{height: '100%', justifyContent: 'center'}}>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='text-muted mt-1 fw-semibold fs-7'>
                    {!idUnitBranch ? "Selecione uma unidade filial primeiro." : plantsToUse.length === 0 ? "Não há usinas SIMPLES disponíveis para esta unidade filial." : "Não há usinas SIMPLES disponíveis."}
                  </span>
                </h3>
              </div>
            )}
          </>
        )}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {ListPlantsForComposite}
